import React from "react";
import "./Footer.css";
import Donor_logos from "../../donor_logos.png";
import Youth_In_Action_logo from "../../youth_in_action_logo.png";
const Footer = ({ footertext, footertext_project, footertext_fund }) => {
  return (
    <div className="footer">
      <img
        src={Donor_logos} // Replace with your logo URL
        alt="Logo"
        width="80%"
        height="2%"
        className="d-inline-block align-top"
      />
      <p>{footertext}</p>
      <div className="footer_top">
      <img
        src={Youth_In_Action_logo} // Replace with your logo URL
        alt="Logo"
        width="10%"
        height="2%"
        className=" footer_logo"
      />
        <p>{footertext_project}</p>
      </div>
      <p>{footertext_fund}</p>
    </div>
  );
};

export default Footer;
